import styled, { keyframes } from 'styled-components';
import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';
import { BaseCard } from 'theme/components/Cards.style';

export const Container = styled('div')`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 15px;
  max-width: 960px;
  padding: 15px 30px;
  width: 100%;

  @media (max-width: ${breakpoints.tablet}) {
    height: fit-content;
    padding: 15px 0 20px 0;
  }
`;

export const EmbeddedContainer = styled(Container)`
  max-width: 600px;

  @media (max-width: ${breakpoints.laptop}) {
    max-width: none;
  }

  @media (max-width: ${breakpoints.tablet}) {
    padding: 15px 15px 20px;
  }
`;

export const Card = styled(BaseCard)`
  gap: 30px;
`;

export const RowsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const DetailRow = styled('div')`
  border-bottom: 1px solid ${colours.neutral[200]};
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-height: 50px;
  padding: 15px 0;
  width: 100%;
`;

export const Actions = styled('div')`
  display: flex;
  gap: 10px;

  & > * {
    flex: 0 0 auto;
    width: fit-content;
  }
`;

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const SpinningIcon = styled('span')`
  animation: ${spin} 2.5s linear infinite;
  display: inline-flex;
`;
